<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Новый пароль</h1>
      <form @submit.prevent="submit">
        <div class="form-field">
          <label for="password">Новый пароль</label>
          <input id="password" v-model="password" type="password" autocomplete="new-password" required />
        </div>
        <div class="form-field">
          <label for="passwordConfirmation">Подтверждение пароля</label>
          <input
            id="passwordConfirmation"
            v-model="passwordConfirmation"
            type="password"
            autocomplete="new-password"
            required
          />
        </div>
        <p v-if="message" class="success-message">{{ message }}</p>
        <p v-if="error" class="error-message">{{ error }}</p>
        <button class="btn" type="submit" :disabled="loading || !token">
          {{ loading ? 'Сохранение...' : 'Сохранить пароль' }}
        </button>
      </form>
      <p v-if="message" style="margin-top: 1rem">
        <router-link to="/login">Перейти ко входу</router-link>
      </p>
      <p v-else-if="!token" style="margin-top: 1rem">
        <router-link to="/forgot-password">Запросить новую ссылку</router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()
const route = useRoute()

const password = ref('')
const passwordConfirmation = ref('')
const loading = ref(false)
const error = ref('')
const message = ref('')
const token = computed(() => route.query.reset_password_token?.toString() || '')

async function submit() {
  if (!token.value) {
    error.value = 'Ссылка для сброса пароля недействительна'
    return
  }

  loading.value = true
  error.value = ''
  message.value = ''

  try {
    const result = await auth.resetPassword(
      token.value,
      password.value,
      passwordConfirmation.value
    )
    message.value = result.message
  } catch (err) {
    const errors = err.response?.data?.errors
    error.value = Array.isArray(errors) ? errors.join(', ') : 'Не удалось изменить пароль'
  } finally {
    loading.value = false
  }
}
</script>
